/**
 * Ticket Category Options
 * Defines the available category values for tickets
 */
export const TICKET_CATEGORY_OPTIONS = [
  { label: "Hardware", value: "hardware" },
  { label: "Software", value: "software" },
  { label: "Network", value: "network" },
  { label: "Security", value: "security" },
  { label: "Backup", value: "backup" },
  { label: "Cloud", value: "cloud" },
  { label: "Email", value: "email" },
  { label: "Phone", value: "phone" },
  { label: "Printer", value: "printer" },
  { label: "Other", value: "other" },
];
